import { CustomerService } from "services/CustomerService";
import { GetApiKeyDto } from "services/Dtos/ApiKeyDtos";
import { SwitcherOption } from "components/common/EntitySwitcher";

const RESULT_LIMIT = 10;
const ALL_KEYS_PAGE_SIZE = 100;
const ALL_KEYS_MAX_PAGES = 50;

// Every API key of a company, sorted by name, for filter dropdowns.
// The endpoint is paged, so this walks the pages until it has them all.
export const getAllApiKeys = async (customerId: number): Promise<GetApiKeyDto[]> => {
  const byId = new Map<number, GetApiKeyDto>();
  for (let page = 1; page <= ALL_KEYS_MAX_PAGES; page++) {
    const response = await CustomerService.customer.getCustomerApiKeys(customerId, page, ALL_KEYS_PAGE_SIZE);
    const keys = response.data.apiKeys ?? [];
    keys.forEach((key) => byId.set(key.id, key));
    if (keys.length === 0 || byId.size >= (response.data.totalCount ?? 0)) break;
  }
  return Array.from(byId.values()).sort((a, b) => a.name.localeCompare(b.name));
};

export const searchCompanies = async (term: string): Promise<SwitcherOption[]> => {
  const response = await CustomerService.customer.getCustomers("name", 1, RESULT_LIMIT, term || undefined);
  return (response.data.items ?? []).map((company) => ({
    id: company.id,
    label: company.name,
    detail: `ID ${company.id}`,
  }));
};
